import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { Collapse } from 'antd';

const CollapseBlock = ({
  collapsible,
  title,
  children,
  closedByDefault = false,
  openOnTrigger = false,
}) => {

  const [activeKey, setActiveKey] = useState(closedByDefault ? [] : ['1']);
  const previousOpenOnTrigger = useRef(openOnTrigger);

  useEffect(() => {
    if (!previousOpenOnTrigger.current && openOnTrigger) {
      setActiveKey(['1']);
    }

    previousOpenOnTrigger.current = openOnTrigger;
  }, [openOnTrigger]);

  const items = [
    {
      key: '1',
      label: title,
      children: <div className="collapse-content">{children}</div>,
    },
  ];

  return (
    <div className="collapse-block-comp-container">
      {collapsible ? (
        <Collapse
          expandIconPlacement="end"
          activeKey={activeKey}
          onChange={(key) => setActiveKey(Array.isArray(key) ? key : [key])}
          bordered={false}
          items={items}
        />
      ) : (
        <div className="wrapper">
          {title ? <div className="title-wrapper">{title}</div> : null}
          <div className="collapse-content">{children}</div>
        </div>
      )}
    </div>
  );
};

CollapseBlock.propTypes = {
  collapsible: PropTypes.bool,
  title: PropTypes.node,
  children: PropTypes.node,
  closedByDefault: PropTypes.bool,
  openOnTrigger: PropTypes.bool,
};

export default CollapseBlock;
